// extracted by mini-css-extract-plugin
export default {"container":"Odometer_container__TfF-I","commaContainer":"Odometer_commaContainer__YOQzW"};